export const PURCHASE_TYPE_REMAINING_POOL = 48;
export const PURCHASE_TYPE_GIVEAWAY_BONUS = 56;



// WEBPACK FOOTER //
// ./src/constants/purchase.js